import http from '@/apis/index';

import serviceConfig from '@/apis/configs/micro-service.config';
import { Service } from '@/configs/enums/basics';

/**
 * 解析服务类型
 * @param {*} url 接口地址
 * @returns
 */
const resolveServiceType = (url: string): string => {
  const servicePattern = new RegExp(
    `/(${Object.values(Service).join('|')})/`,
    'g',
  );
  const match = url.match(servicePattern);
  if (match) {
    // 注意：这里假设Service对象的值是直接对应服务名称的字符串
    const serviceName = match[0].replace('/', '');
    // 这里需要额外的检查来确保Service[serviceName]存在且有效
    // 因为如果URL中的服务名称不在Service对象中，直接访问会导致undefined
    return Service[serviceName] || Service.基础服务; // 默认为基础服务
  }
  return Service.基础服务;
};

/**
 * 封装请求
 */
const myRequest = {
  baseRequest(method: string, url: string, data: any, config?: any) {
    const service = resolveServiceType(url);

    return http[method](url, data, {
      baseURL: serviceConfig.default[service].url,
      ...config,
    });
  },
  get(url: string, data?: any, config?: any) {
    return this.baseRequest('get', url, data, config);
  },
  post(url: string, data?: any, config?: any) {
    return this.baseRequest('post', url, data, config);
  },
  /**
   *（application/x-www-form-urlencoded）
   * @param url
   * @param data
   * @param config
   * @returns
   */
  postPreset(url: string, data?: any, config?: any) {
    return this.baseRequest('postPreset', url, data, config);
  },
  /**
   *（application/json）
   * @param url
   * @param data
   * @param config
   * @returns
   */
  postJson(url: string, data?: any, config?: any) {
    return this.baseRequest('postJson', url, data, config);
  },
  /**
   *（multipart/form-data）
   * @param url
   * @param data
   * @param config
   * @returns
   */
  postWithFile(url: string, data?: any, config?: any) {
    return this.baseRequest('postWithFile', url, data, config);
  },
};

export default myRequest;
